export default __webpack_public_path__ + "static/media/5.89463cd6.svg";